export { default } from "./SponsorMidAdv";
